import { lazy, Suspense } from 'preact/compat'
import IntroModal from './ui/organisms/IntroModal'
import LoadingCameraModal from './ui/organisms/LoadingCameraModal'
import LoadingModal from './ui/organisms/LoadingModal'
import MainPage from './ui/organisms/MainPage'
import UpdateAvailableNotification from './ui/molecules/UpdateAvailableNotification'

// Lazy load only error/modal components that may not be shown
const NoCameraAccessModal = lazy(() => import('./ui/organisms/NoCameraAccessModal'))
const PartiallySupportedBrowserModal = lazy(() =>
  import('./ui/organisms/UnsupportBrowserModals').then((m) => ({
    default: m.PartiallySupportedBrowserModal,
  }))
)
const UnsupportedBrowserModal = lazy(() =>
  import('./ui/organisms/UnsupportBrowserModals').then((m) => ({
    default: m.UnsupportedBrowserModal,
  }))
)
const LicenseErrorModal = lazy(() => import('./ui/organisms/LicenseErrorModal'))
const NoCameraAvailableModal = lazy(() => import('./ui/organisms/NoCameraAvailableModal'))

export function App() {
  return (
    <>
      <LoadingModal />
      <IntroModal />
      <LoadingCameraModal />
      <MainPage />
      <Suspense fallback={null}>
        <NoCameraAvailableModal />
        <NoCameraAccessModal />
        <UnsupportedBrowserModal />
        <PartiallySupportedBrowserModal />
        <LicenseErrorModal />
      </Suspense>
      <UpdateAvailableNotification />
    </>
  )
}
